module.exports = __webpack_public_path__ + "img/hinase_title3.fa67b703.jpg";